import { SearchInput } from '@shared/Ui/CustomInputs/SearchInput/SearchInput';
import ItemProgressBar from '@shared/Ui/ProgressBars/ItemProgressBar/ItemProgressBar';
import { SortArrowIcon } from '@shared/Icons/SortArrowIcon';
import BasicButton from '@shared/Ui/Buttons/BasicButton/BasicButton';
import css from './ItemsSelectionModalHeader.module.css';
import classNames from 'classnames';
import { ChangeEvent, useState } from 'react';
import { SortParamEnum, SortParamType } from '@shared/Enums/SortParamEnum';
import { notifySuccessCustom } from '@shared/Widgets/ToastNotifications/ToastNotifications';
import { ItemTypeEntity } from '@entities/ItemType/Types';
import { SelectItemsModalElementsIdsEnum } from '@modules/Steps/Shared/Enums/SelectItemsModalElementsIdsEnum';
import ClearButton from '@shared/Ui/Buttons/ClearButton/ClearButton';
import { ItemTypeViewModel } from '@viewModels/ItemTypeViewModel/ItemTypeViewModel';

interface ItemsSelectionModalHeaderProps {
    changeSearch: (query: string) => void;
    search: string;
    changeSortBy: (sortBy: SortParamType) => void;
    itemType: ItemTypeEntity;
}

export const ItemsSelectionModalHeader: React.FC<
    ItemsSelectionModalHeaderProps
> = ({ itemType, search, changeSearch, changeSortBy }) => {
    const { unit, qty } = itemType;

    const itemTypeViewModel = new ItemTypeViewModel();

    const totalSelectedItemsQty =
        itemTypeViewModel.calculateTotalQuantityFromItemType(itemType);

    const handleChangeSearch = (event: ChangeEvent<HTMLInputElement>) => {
        changeSearch(event.target.value);
    };
    const handleSortByAsc = () => {
        changeSortBy(SortParamEnum.ASC);
    };

    const handleSortByDesc = () => {
        changeSortBy(SortParamEnum.DESC);
    };

    const handleClearItemsQuantity = () => {
        itemTypeViewModel.clearItemTypeQuantity(itemType);
        notifySuccessCustom('All input fields have been reset.');
    };

    return (
        <div
            className={css.header}
            id={SelectItemsModalElementsIdsEnum.SELECT_MODAL_STEP2_HEADER}
        >
            <div className={css.headerText}>
                <div>Please, select your items</div>
                <SearchInput onChange={handleChangeSearch} value={search} />
            </div>
            <div
                className={css.controls}
                id={
                    SelectItemsModalElementsIdsEnum.SELECT_MODAL_STEP2_PROGRESSBAR
                }
            >
                <ItemProgressBar
                    total={qty}
                    current={totalSelectedItemsQty}
                    unit={unit}
                    divider={' of '}
                    progressTextClassName={css.progressText}
                />
                <div className={css.btns}>
                    <ClearButton
                        onClick={handleClearItemsQuantity}
                        id={
                            SelectItemsModalElementsIdsEnum.SELECT_MODAL_STEP2_CLEAR_BUTTON
                        }
                    />
                    <div className={css.sortBtns}>
                        <BasicButton
                            className={css.btn}
                            onClick={handleSortByAsc}
                        >
                            <SortArrowIcon />
                        </BasicButton>
                        <BasicButton
                            className={classNames(css.btn, css.reversed)}
                            onClick={handleSortByDesc}
                        >
                            <SortArrowIcon />
                        </BasicButton>
                    </div>
                </div>
            </div>
        </div>
    );
};
